import React from 'react';
import Head from 'next/head';

const PageHead = ({ meta }) => {
  const {
    seoTitle,
    seoDescription,
    seoRobots,
    url,
    ogImage
  } = meta;

  let seoRobotsContent = 'index, follow';

  if (seoRobots) {
    seoRobotsContent = 'noindex, follow';
  }

  if (process.env.seoAllowIndexing === false) {
    seoRobotsContent = 'noindex, nofollow';
  }

  return (
    <Head>
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={seoRobotsContent} />
      <link rel="dns-prefetch" href="https://optimise2.assets-servd.host/" />
    </Head>
  );
};

export default PageHead;
